import { Component } from '@angular/core';
import { GalleriaModule } from 'primeng/galleria';

@Component({
  selector: 'app-property-choose',
  imports: [GalleriaModule],
  templateUrl: './property-choose.component.html',
  styleUrl: './property-choose.component.scss',
})
export class PropertyChooseComponent {
  images = [
    'https://unsplash.com/photos/qiiMXEbrFjI/download?force=true&w=400',
    'https://unsplash.com/photos/qiiMXEbrFjI/download?force=true&w=400',
    'https://unsplash.com/photos/qiiMXEbrFjI/download?force=true&w=400',
  ];

  responsiveOptions: any[] = [
    {
      breakpoint: '991px',
      numVisible: 4,
    },
    {
      breakpoint: '767px',
      numVisible: 3,
    },
    {
      breakpoint: '575px',
      numVisible: 1,
    },
  ];

  ngOnInit() {}
}
